import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import ScenarioSelectionAssumptionSections
  from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionAssumptionsAndDetails/Layout/ScenarioSelectionAssumptionsPicker/ScenarioSelectionAssumptions/ScenarioSelectionAssumptionSections/ScenarioSelectionAssumptionSections';
import { FDHeadlineText } from '@facet-wealth/design';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => ScenarioSelectionAssumptionSections,
  }, overrideReadOnly);

export default metaOverrideSet;
